import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Product } from '@app/akita/api/products/models/product.model';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';
import { AkitaScreenQuery } from '@app/akita/screen/state/screen.query';
import { ScreenSizeInfoState } from '@app/akita/screen/state/screen.store';
import { ArrowRight1IconComponent } from '@app/shared/components/icons/generated/arrow-right-1/arrow-right-1.component';
import { TranslocoModule } from '@ngneat/transloco';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-collection-title',
  templateUrl: './collection-title.template.html',
  styleUrls: ['./collection-title.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslocoModule, RouterModule, ArrowRight1IconComponent],
})
export class CollectionTitleComponent {
  @Input() public product?: Product | null;
  @Input() public category?: string | null;
  @Input() public brand?: string | null;
  @Input() public model?: string | null;
  @Input() public showShortText?: boolean | null = false;

  public readonly lessThan$: Observable<ScreenSizeInfoState>;

  public readonly isRtl$: Observable<boolean>;

  constructor(
    private readonly akitaRouterQuery: AkitaRouterQuery,
    private readonly akitaScreenQuery: AkitaScreenQuery
  ) {
    this.isRtl$ = this.akitaRouterQuery.selectIsRtlLayout();
    this.lessThan$ = this.akitaScreenQuery.selectLessThan();
  }

  public capitalizeCategory(str: string): string | null {
    return str
      .charAt(0)
      .toUpperCase()
      .concat(str.slice(1).replace(/ /g, '_').toLowerCase());
  }
}
